import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {NexioResponse} from '../../../graphql/payments.datatypes';

interface PaymentData {
    getNexioToken: NexioResponse
}

export const GET_PAYMENT_QUERY = gql`
    query getNexioToken($amount: Float!, $paymentType: Int!, $billingPartyMemberId: Int!){
        getNexioToken(amount: $amount, paymentType: $paymentType, billingPartyMemberId: $billingPartyMemberId){
            status
            baseUrl
            error
            expiration
            token
            fraudUrl
        }
    }
`;

export const getNexioToken = (amount: number, paymentType: number, billingPartyMemberId: number) => {
    return useQuery<PaymentData>(
        GET_PAYMENT_QUERY,
        {
            fetchPolicy: 'no-cache',
            variables: {
                amount,
                paymentType,
                billingPartyMemberId,
            },

        }
    );
};

export default getNexioToken;
